@if (placeholderPath) {
  <div [style]="{ 'background-image': 'url(' + placeholderPath + ')' }" class="placeholder"></div>
}
@if (hasImage) {
  <img [src]="baseImagePath" alt="" class="bg" />
}
